import { makeStyles } from '@material-ui/core/styles';
import darkImage from './images/microsoft-sign-in-btn-dark.png';
import lightImage from './images/microsoft-sign-in-btn-light.png';

const useStyles = makeStyles({
    root: {
        backgroundImage: (props) => (props.theme === 'light' ? `url(${lightImage})` : `url(${darkImage})`),
        height: '41px',
        width: '215px',
        border: (props) => (props.theme === 'light' ? '1px #8C8C8C' : 'none'),
        borderRadius: 0,
    },
});

export default useStyles;
